import { useMemo } from "react";
import { format as dateFNSFormat } from "date-fns";
import useTranslations from "./useTranslations";
import useDateFnsLocale from "./useDateFnsLocale";

type FormatDateType = (options: {
  date: Date | string;
  format?: "long" | "short";
  fallback?: string;
}) => string;

export function dateFormatter(
  date: Date | string | number = new Date(),
  format: string,
  fallback: string,
  locale: Locale
) {
  if (!date) return fallback;

  return dateFNSFormat(new Date(date), format, { locale });
}

// TODO: it would be better to split this file into a function and a hook that uses this
// function + useMemo, but we will first need to do it for useTranslations and useDateFnsLocale
const useFormatDate: FormatDateType = ({ date, format = "long", fallback }) => {
  const t = useTranslations();
  const dateFnsLocale = useDateFnsLocale();

  const formattedDate = useMemo(
    () =>
      dateFormatter(
        date,
        t(`dateFormat.${format}` as const) as string,
        fallback || (t("dateFormat.fallback") as string),
        dateFnsLocale
      ),
    [date]
  );

  return formattedDate;
};

export default useFormatDate;
